import React from 'react';
import PropTypes from 'prop-types';
import Textarea from './Textarea';
import {
  Input,
  FileInput,
  Select,
  SelectWrapper,
  FormLabel,
  Radio,
  SoundGroup,
  Checkbox,
  UserProfile
} from './styles';
import style from './styles';
import TimeField from 'react-simple-timefield';
import ReactAudioPlayer from 'react-audio-player';
import Toggle from 'react-toggle';

const propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  round: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onFocus: PropTypes.func,
  componentClass: PropTypes.oneOf([
    'select',
    'radio',
    'checkbox',
    'textarea',
    'input'
  ])
};

const defaultProps = {
  componentClass: 'input',
  required: false,
  defaultChecked: false,
  disabled: false
};

const renderElement = (Element, attributes, type, child) => {
  return (
    <FormLabel key={attributes.key ? attributes.key : null}>
      <Element {...attributes} type={type} />
      <span>
        {child && '\u00a0\u00a0'}
        {child}
      </span>
    </FormLabel>
  );
};

class FormControl extends React.Component {
  renderFileName(selectedFile) {
    if (selectedFile) {
      return <span>{selectedFile.name}</span>;
    } else {
      return '';
    }
  }
  render() {
    const props = this.props;
    const childNode = props.children;
    const elementType = props.componentClass;
    // cancel custom browser default form validation error
    const onChange = e => {
      e.target.classList.remove('form-invalid');

      props.onChange && props.onChange(e);
    };

    const attributes = {
      onChange,
      onKeyPress: props.onKeyPress,
      onClick: props.onClick,
      onKeyDown: props.onKeyDown,
      value: props.value,
      defaultValue: props.defaultValue,
      [props.defaultChecked
        ? 'defaultChecked'
        : 'checked']: props.defaultChecked
        ? props.defaultChecked
        : props.checked,
      placeholder: props.placeholder,
      type: props.type,
      name: props.name,
      round: props.round,
      required: props.required,
      disabled: props.disabled,
      onFocus: props.onFocus,
      autoFocus: props.autoFocus,
      accept: props.accept,
      step: props.step || "1",
      min: props.min,
      max: props.max,
      id: props.id,
      pattern: props.pattern,
   
    };

    if (elementType === 'select') {
      if (props.options) {
        return (
          <SelectWrapper>
            <Select {...attributes}>
              {props.options.map((option, index) => {
                return (
                  <option key={index} value={option.value || ''}>
                    {option.label || ''}
                  </option>
                );
              })}
            </Select>
          </SelectWrapper>
        );
      }
      return (
        <SelectWrapper>
          <Select {...attributes}>{childNode}</Select>
        </SelectWrapper>
      );
    }

    if (elementType === 'radio') {
      if (props.options) {
        return props.options.map((option, index) => {
          return renderElement(
            Radio,
            { key: index, ...attributes, ...option },
            elementType,
            option.childNode
          );
        });
      }

      return renderElement(Radio, attributes, elementType, childNode);
    }

    if (elementType === 'checkbox') {
      return renderElement(Checkbox, attributes, elementType, childNode);
    }

    if (elementType === 'textarea') {
      return <Textarea {...props} />;
    }

    if (elementType === 'timePicker') {
      return (
        <TimeField
          style={{
            border: 'none',
            width: '100%',
            height: '34px',
            padding: '10px',
            color: '#444',
            'border-bottom': '1px solid #DDD',
            background: 'none',
            transition: 'all 0.3s ease'
          }}
          {...props}
        />
      );
    }

    if (elementType === 'audioPlayer') {
      return (
        <ReactAudioPlayer
          style={{
            border: 'none',
            width: '100%',
            height: '60px',
            padding: '0px',
            color: '#444'
          }}
          {...props}
        />
      );
    }

    if (elementType === 'audioPlayer30') {
      return (
        <ReactAudioPlayer
          style={{
            border: 'none',
            width: '100%',
            height: '30px',
            padding: '0px',
            color: '#444'
          }}
          {...props}
        />
      );
    }

    if (elementType === 'audioStreamer25') {
      return (
        <audio
          style={{
            border: 'none',
            width: '100%',
            height: '25px',
            padding: '0px',
            color: '#444'
          }}
          controls="controls"
        >
          <source {...props} type="audio/wav" />
        </audio>
      );
    }

    if (elementType === 'audioStreamer') {
      return (
        <audio
          style={{
            border: 'none',
            width: '100%',
            height: '60px',
            padding: '0px',
            color: '#444'
          }}
          controls="controls"
        >
          <source {...props} type="audio/wav" />
        </audio>
      );
    }

    if (elementType === 'toggle') {
      return (
        <div
          style={{
            width: '100%',
            'padding-left': '80%',
            height: '34px'
          }}
        >
          <Toggle
            icons={{
              checked: null,
              unchecked: null
            }}
            {...props}
          />
        </div>
      );
    }
    if (elementType === 'file') {
      // console.log('props.selectedFile ', props.selectedFile);
      return (
        <SoundGroup>
          <img src="/images/file.png" />
          <span>
            Select or drop a file to upload. <br />
            {this.renderFileName(props.selectedFile)}{' '}
          </span>

          <FileInput {...attributes} />
        </SoundGroup>
      );
    }
    if (elementType === 'user_file') {
      // console.log('props.selectedFile ', props.selectedFile);
      return (
        <UserProfile>
          <img src="/images/avatar-colored.svg" />
          <span>
            Select or drop a Profile Pic. <br />
            {this.renderFileName(props.selectedFile)}{' '}
          </span>

          <FileInput {...attributes} />
        </UserProfile>
      );
    }

    return <Input  {...attributes} />;
  }
}

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;

export default FormControl;



// WEBPACK FOOTER //
// src/modules/common/components/form/Control.js